(function($){
    Drupal.behaviors.mo6 = {
        attach() {
            $('.MO6__list__link a').click(function(e){
                var href = $(this).attr('href');
                if (href === '' || href === '#') {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
            });

            $('body').addClass('overlay--closed');

            // Desktop.
            var $controls = $('.MO6__nav--desktop li.has-children');

            $controls.mouseenter(openDesktopDropdown);
            $controls.keypress(openDesktopDropdown);

            $controls.mouseleave(function() {
                var $this = $(this);
                $this.addClass('closing').removeClass('opened');
                $('.MO6__list__link a', $this).removeClass('active');
                setTimeout(function(){
                    $this.removeClass('closing');
                }, 250);
            });

            function openDesktopDropdown(e) {
                if (e.which === 13 || e.type === 'mouseenter') {
                    var $this = $(this);
                    $this.removeClass('closing').addClass(['opened']);
                    $('.MO6__list__link a', $this).addClass('active');
                }
            }

            // Mobile.
            var $mobileMenu = $('.MO6--mobile');

            $('.MO6__burger-menu').click(function(){
                $mobileMenu.addClass('animating').addClass('opened');
                $('body').addClass('no-scroll overlay--animating overlay--opened');
                setTimeout(function(){
                    $mobileMenu.removeClass('animating');
                    $('body').removeClass('overlay--animating');
                }, 300);
            });
            $('.MO6--mobile__close').click(function(){
                $mobileMenu.addClass('animating').removeClass('opened');
                $('body').addClass('overlay--animating').removeClass('no-scroll overlay--opened');
                setTimeout(function(){
                    $mobileMenu.removeClass('animating');
                    $('body').removeClass('overlay--animating');
                }, 300);
            });

            $('li.has-children', $mobileMenu).click(toggleMobileDropdown);
            $('li.has-children', $mobileMenu).keypress(toggleMobileDropdown);

            function toggleMobileDropdown(e) {
                if (e.which === 13 || e.type === 'click') {
                    var $this = $(this);
                    if ($this.hasClass('opened')) {
                        $this.removeClass('opened');
                        $('.MO6__list', $this).slideUp(250);
                    } else {
                        $this.addClass('opened');
                        $('.MO6__list', $this).slideDown(250);
                    }
                }
            }

            $('.MO6__list .MO6__list a', $mobileMenu).click(function(e){
                e.stopPropagation();
            });
        }
    };
})(jQuery);
